const ICON = {
  chevronLeft: `<svg xmlns="http://www.w3.org/2000/svg" class="h-5 w-5" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="m15 18-6-6 6-6"/></svg>`,
  chevronRight: `<svg xmlns="http://www.w3.org/2000/svg" class="h-5 w-5" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="m9 18 6-6-6-6"/></svg>`,
  starFilled: `<svg xmlns="http://www.w3.org/2000/svg" class="h-4 w-4 fill-yellow-400 text-yellow-400" viewBox="0 0 24 24" fill="currentColor" stroke="currentColor" stroke-width="2" aria-hidden="true"><path d="M12 2l3.09 6.26L22 9.27l-5 4.87 1.18 6.88L12 17.77l-6.18 3.25L7 14.14 2 9.27l6.91-1.01L12 2z"/></svg>`,
  starOutline: `<svg xmlns="http://www.w3.org/2000/svg" class="h-4 w-4 text-foreground/20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" aria-hidden="true"><path d="M12 2l3.09 6.26L22 9.27l-5 4.87 1.18 6.88L12 17.77l-6.18 3.25L7 14.14 2 9.27l6.91-1.01L12 2z"/></svg>`,
  checkVerified: `<svg xmlns="http://www.w3.org/2000/svg" class="h-4 w-4 fill-[var(--brand-teal-deep)] text-white" viewBox="0 0 24 24" fill="currentColor" stroke="currentColor" stroke-width="2" aria-hidden="true"><path d="M12 22c5.523 0 10-4.477 10-10S17.523 2 12 2 2 6.477 2 12s4.477 10 10 10z"/><path d="m9 12 2 2 4-4" class="text-white" fill="none" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg>`,
  checkVerifiedSm: `<svg xmlns="http://www.w3.org/2000/svg" class="h-3.5 w-3.5 fill-[var(--brand-teal-deep)] text-white" viewBox="0 0 24 24" fill="currentColor" stroke="currentColor" stroke-width="2" aria-hidden="true"><path d="M12 22c5.523 0 10-4.477 10-10S17.523 2 12 2 2 6.477 2 12s4.477 10 10 10z"/><path d="m9 12 2 2 4-4" fill="none" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg>`,
  gift: `<svg xmlns="http://www.w3.org/2000/svg" class="h-3.5 w-3.5 text-foreground/50" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="2" aria-hidden="true"><rect x="3" y="8" width="18" height="4" rx="1"/><path d="M12 8v13"/><path d="M19 12v7a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2v-7"/><path d="M7.5 8a2.5 2.5 0 0 1 0-5A4.8 8 0 0 1 12 8a4.8 8 0 0 1 4.5-5 2.5 2.5 0 0 1 0 5"/></svg>`,
  heart: `<svg xmlns="http://www.w3.org/2000/svg" class="h-3.5 w-3.5 fill-rose-400 text-rose-400" viewBox="0 0 24 24" fill="currentColor" aria-hidden="true"><path d="M19 14c1.49-1.46 3-3.21 3-5.5A5.5 5.5 0 0 0 16.5 3c-1.76 0-3 .5-4.5 2-1.5-1.5-2.74-2-4.5-2A5.5 5.5 0 0 0 2 8.5c0 3.78 3.4 6.86 8.55 11.54L12 21.35l1.45-1.32C18.6 15.36 22 12.28 22 8.5A5.5 5.5 0 0 0 19 14z"/></svg>`,
  chevronUp: `<svg xmlns="http://www.w3.org/2000/svg" class="h-3.5 w-3.5" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="2" aria-hidden="true"><path d="m18 15-6-6-6 6"/></svg>`,
  chevronDown: `<svg xmlns="http://www.w3.org/2000/svg" class="h-3.5 w-3.5" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="2" aria-hidden="true"><path d="m6 9 6 6 6-6"/></svg>`,
};

const testimonialsList = [
  {
    title: "Finally, my mouth doesn't feel like cotton",
    body: "I started chewing LarineCo™ after lunch and before bed and the dry, sticky feeling I'd been dealing with on my GLP-1 is so much better. It's the first thing that actually helped.",
    name: "Megan",
  },
  {
    title: "My breath feels fresh again",
    body: "Between dry mouth and skipping meals, my breath was rough. A piece of LarineCo™ after coffee or a meeting and I feel confident talking to anyone.",
    name: "Priya",
  },
  {
    title: "GLP-1 + LarineCo™ = my new routine",
    body: "I keep a box in my bag, my car, and on my nightstand. It tastes great and my teeth feel smoother and cleaner than they have in months.",
    name: "Jordan",
  },
  {
    title: "Sensitive teeth are calmer",
    body: "Cold drinks used to make me wince. After a few weeks of chewing LarineCo™ my teeth just feel less reactive. I'm a believer in nano-hydroxyapatite now.",
    name: "Alyssa",
  },
  {
    title: "Tastes amazing, no weird aftertaste",
    body: 'Most "healthy" gums taste like cardboard. LarineCo™ actually tastes good and I don\'t feel guilty chewing a few pieces a day.',
    name: "Chris",
  },
  {
    title: "Smile looks brighter, no harsh stuff",
    body: "I didn't want strips or bleach. My teeth look noticeably cleaner and a little brighter, and that's enough for me.",
    name: "Dani",
  },
];

const productReviewsData = [
  { name: "Jasmine R.", time: "17 minutes ago", title: "Finally something that helps with dry mouth", body: "Since starting my GLP-1, my mouth always felt sticky. A piece of LarineCo™ after meals and I feel normal again. Berry is my favorite.", flavor: "Berry / 18 pcs", photo: "https://cdn.shopify.com/s/files/1/0904/3869/7251/files/box-berry.jpg?v=1778340734", rating: 5, ageMinutes: 17 },
  { name: "Tom W.", time: "38 minutes ago", title: "Tastes amazing", body: "Cinnamon is a vibe. Doesn't lose flavor in two minutes like other gums.", flavor: "Cinnamon / 18 pcs", photo: "https://cdn.shopify.com/s/files/1/0904/3869/7251/files/box-cinnamon.jpg?v=1778340735", rating: 5, ageMinutes: 38 },
  { name: "Renee P.", time: "1 hour ago", title: "Smile feels cleaner", body: "My teeth feel polished after I chew a piece. I keep one in my purse and one in my car now.", flavor: "Peppermint / 18 pcs", rating: 5, ageMinutes: 60 },
  { name: "Marcus J.", time: "2 hours ago", title: "Fresher breath instantly", body: "Quick fix between meetings. I don't feel self-conscious anymore.", flavor: "Mastic Mint / 18 pcs", rating: 4, ageMinutes: 120 },
  { name: "Hannah K.", time: "4 hours ago", title: "That sharp zing from cold drinks is gone", body: "Cold drinks don't make me wince like before. The nano-hydroxyapatite stuff really seems to help.", flavor: "Berry / 18 pcs", rating: 5, ageMinutes: 240 },
  { name: "Devon L.", time: "6 hours ago", title: "Easy add to my GLP-1 routine", body: "I keep forgetting to drink water. This actually helps my mouth feel less dry between sips.", flavor: "Peppermint / 18 pcs", photo: "https://cdn.shopify.com/s/files/1/0904/3869/7251/files/box-peppermint.jpg?v=1778340733", rating: 5, ageMinutes: 360 },
  { name: "Olivia S.", time: "9 hours ago", title: "Love the packaging", body: "A tree planted in every box is a nice touch. Box is sturdy and slim.", flavor: "Berry / 18 pcs", rating: 4, ageMinutes: 540 },
  { name: "Andre B.", time: "12 hours ago", title: "Brighter smile in a few weeks", body: "Teeth look noticeably cleaner. No bleach or strips required.", flavor: "Berry / 18 pcs", rating: 5, ageMinutes: 720 },
  { name: "Priscilla M.", time: "18 hours ago", title: "Mint without the burn", body: "Most mint gums are too aggressive. This one is smooth.", flavor: "Mastic Mint / 18 pcs", rating: 5, ageMinutes: 1080 },
  { name: "Kyle T.", time: "1 day ago", title: "Convenient pocket-size", body: "Fits in any pocket. Goes everywhere with me.", flavor: "Mastic Mint / 18 pcs", photo: "https://cdn.shopify.com/s/files/1/0904/3869/7251/files/box-mastic-mint.jpg?v=1778340732", rating: 5, ageMinutes: 1440 },
  { name: "Beth A.", time: "1 day ago", title: "Sugar-free and tastes great", body: "I usually hate sugar-free gum. This is the exception.", flavor: "Cinnamon / 18 pcs", rating: 4, ageMinutes: 1500 },
  { name: "Sofia G.", time: "2 days ago", title: "Helps me skip the mints", body: "Replaced my old mints with these. Way better for my teeth and mouth feel.", flavor: "Peppermint / 18 pcs", rating: 5, ageMinutes: 2880 },
  { name: "Nathan H.", time: "2 days ago", title: "Worth it", body: "Pricey vs drugstore gum but you can taste the difference and my dentist noticed less plaque.", flavor: "Berry / 18 pcs", rating: 4, ageMinutes: 2940 },
  { name: "Maya D.", time: "3 days ago", title: "GLP-1 friendly routine", body: "Carry a box with me daily. My mouth feels normal again, which is huge.", flavor: "Mastic Mint / 18 pcs", rating: 5, ageMinutes: 4320 },
];

const storeReviewsData = [
  { name: "Don K.", time: "3 days ago", title: "Smooth reorder experience", body: "Subscription was easy to set up and easy to pause. Customer service replied within a day when I asked to swap flavors.", rating: 5, ageMinutes: 4320 },
  { name: "Kelly M.", time: "5 days ago", title: "Sold!", body: "I have been buying LarineCo™ for a few months now. Tried other gums, this one is far better and the checkout is painless.", rating: 5, ageMinutes: 7200 },
  { name: "Sheena S.", time: "1 week ago", title: "Husband and I both reorder", body: "We split a subscription. Boxes always arrive on time and packaging is recyclable. No complaints from either of us.", rating: 5, ageMinutes: 10080 },
  { name: "Lisa B.", time: "1 week ago", title: "Wonderful customer service", body: "Had a question about my shipment and got a real human reply same day. Box arrived exactly when promised.", rating: 5, ageMinutes: 10200 },
  { name: "Shari S.", time: "2 weeks ago", title: "It's working for me", body: "I love that the site explains the ingredients clearly. No marketing fluff. Reorder process is one click.", rating: 4, ageMinutes: 20160 },
  { name: "Linda H.", time: "2 weeks ago", title: "Worth trying, glad I did", body: "First order arrived in three days with a handwritten thank-you. Little touches like that earn loyalty.", rating: 5, ageMinutes: 20300 },
  { name: "Nicole R.", time: "3 weeks ago", title: "Feels good supporting them", body: "A tree planted with every box, transparent ingredients, and fast shipping. Easy brand to keep buying from.", rating: 5, ageMinutes: 30240 },
  { name: "Julie F.", time: "3 weeks ago", title: "Great packaging", body: "Boxes look premium and ship without damage. Subscription page is super clear about next charge dates.", rating: 5, ageMinutes: 30400 },
  { name: "Dlynne P.", time: "1 month ago", title: "High marks", body: "Site is clean, checkout is quick, and the bundle savings are real. Will keep ordering.", rating: 5, ageMinutes: 43200 },
  { name: "Melissa P.", time: "1 month ago", title: "Don't wait, order now", body: "I dragged my feet for weeks. The trial bundle made it risk-free. Glad I finally pulled the trigger.", rating: 5, ageMinutes: 43500 },
  { name: "Adriana R.", time: "1 month ago", title: "Amazing service", body: "Asked about a missing piece in my box, they overnighted a replacement. That kind of follow-through is rare.", rating: 5, ageMinutes: 43800 },
  { name: "Karen E.", time: "2 months ago", title: "Great brand", body: "Excellent communication, ships fast, the unboxing feels intentional. Reordering is one tap.", rating: 4, ageMinutes: 86400 },
  { name: "Beverly W.", time: "2 months ago", title: "These guys are amazing", body: "Every interaction has been smooth. Order, shipping, support, all easy. The product earns the reorder, the brand earns the loyalty.", rating: 5, ageMinutes: 86600 },
];

const productSummary = {
  avg: "4.82",
  count: "2,418 reviews",
  distribution: [
    { stars: 5, pct: 88 },
    { stars: 4, pct: 9 },
    { stars: 3, pct: 2 },
    { stars: 2, pct: 1 },
    { stars: 1, pct: 0 },
  ],
};

const storeSummary = {
  avg: "4.92",
  count: "63 reviews",
  distribution: [
    { stars: 5, pct: 92 },
    { stars: 4, pct: 5 },
    { stars: 3, pct: 1 },
    { stars: 2, pct: 2 },
    { stars: 1, pct: 0 },
  ],
};

function escapeHtml(s) {
  return String(s).replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;").replace(/"/g, "&quot;");
}

/** --- Nano-HA compare slider (NanoHaCompare.tsx) --- */
function initNanoCompare() {
  const range = document.getElementById("nano-range");
  const afterImg = document.getElementById("nano-after");
  const line = document.getElementById("nano-line");
  const handle = document.getElementById("nano-handle");
  const labelAcid = document.getElementById("nano-label-acid");
  const labelNano = document.getElementById("nano-label-nano");

  if (!range || !afterImg || !line || !handle || !labelAcid || !labelNano) return;

  let sliderPosition = Number(range.value) || 52;

  function apply() {
    afterImg.style.clipPath = `inset(0 0 0 ${sliderPosition}%)`;
    line.style.left = `${sliderPosition}%`;
    handle.style.left = `${sliderPosition}%`;
    labelAcid.style.opacity = sliderPosition > 5 ? "1" : "0";
    labelNano.style.opacity = sliderPosition < 95 ? "1" : "0";
  }

  apply();
  range.addEventListener("input", () => {
    sliderPosition = Number(range.value);
    apply();
  });
}

/** --- Testimonials carousel (TestimonialsCarousel.tsx) --- */
function initTestimonialsCarousel() {
  const scroller = document.getElementById("testimonials-scroller");
  if (!scroller) return;

  const dotsWrap = document.getElementById("testimonial-dots");
  if (dotsWrap) {
    dotsWrap.innerHTML = testimonialsList
      .map(
        (_, i) =>
          `<button type="button" data-testimonial-dot data-index="${i}" aria-label="Go to testimonial ${i + 1}" class="h-2 w-2 rounded-full bg-foreground/25 transition-all"></button>`,
      )
      .join("");
  }

  const cardRefs = Array.from(document.querySelectorAll("[data-testimonial-card]"));

  /** @type {HTMLButtonElement[]} */
  const dotButtons = Array.from(document.querySelectorAll("[data-testimonial-dot]"));

  let active = 0;

  function setDotStyles() {
    dotButtons.forEach((btn, i) => {
      const on = i === active;
      btn.className = `h-2 rounded-full transition-all ${on ? "w-6 bg-[var(--brand-teal-deep)]" : "w-2 bg-foreground/25"}`;
    });
  }

  const observer = new IntersectionObserver(
    (entries) => {
      const visible = entries
        .filter((e) => e.isIntersecting)
        .sort((a, b) => b.intersectionRatio - a.intersectionRatio);
      if (visible[0]) {
        const idx = Number(/** @type {HTMLElement} */ (visible[0].target).dataset.index);
        if (!Number.isNaN(idx)) {
          active = idx;
          setDotStyles();
        }
      }
    },
    { root: scroller, threshold: [0.5, 0.75, 1] },
  );

  cardRefs.forEach((el) => observer.observe(el));

  function scrollByDir(dir /* 1 | -1 */) {
    const card = cardRefs[0];
    const step = card ? card.getBoundingClientRect().width + 24 : scroller.clientWidth * 0.9;
    scroller.scrollBy({ left: dir * step, behavior: "smooth" });
  }

  document.getElementById("testimonials-prev")?.addEventListener("click", () => scrollByDir(-1));
  document.getElementById("testimonials-next")?.addEventListener("click", () => scrollByDir(1));

  dotButtons.forEach((btn, i) => {
    btn.addEventListener("click", () => {
      const card = cardRefs[i];
      card?.scrollIntoView({ behavior: "smooth", inline: "start", block: "nearest" });
    });
  });

  setDotStyles();
}

/** --- Product reviews (ProductReviews.tsx) --- */
function initials(name) {
  return name
    .split(" ")
    .map((p) => p[0])
    .join("")
    .slice(0, 2)
    .toUpperCase();
}

function voteKey(r) {
  return r.name + r.time;
}

function baseHelpful(r) {
  let h = 0;
  const k = voteKey(r);
  for (let i = 0; i < k.length; i++) h = (h * 31 + k.charCodeAt(i)) >>> 0;
  return (h % 40) + 3;
}

const reviewState = {
  tab: /** @type {"product"|"store"} */ ("product"),
  expanded: false,
  sort: /** @type {"latest"|"oldest"|"highest"|"lowest"} */ ("latest"),
  rating: /** @type {"all"|"5"|"4"|"3"|"2"|"1"} */ ("all"),
  photosOnly: false,
  /** @type {Record<string, { vote?: "up" | "down"; count: number }>} */
  reviewVotes: {},
};

function handleVote(r, dir) {
  const key = voteKey(r);
  const prev = reviewState.reviewVotes[key];
  const current = prev ?? { vote: undefined, count: baseHelpful(r) };
  if (dir === "up") {
    reviewState.reviewVotes[key] = {
      vote: current.vote ? undefined : "up",
      count: current.count + (current.vote === "up" ? -1 : 1),
    };
  } else {
    reviewState.reviewVotes[key] = {
      vote: current.vote ? undefined : "down",
      count: current.count + (current.vote === "down" ? 1 : -1),
    };
  }
}

function filteredSortedReviews() {
  const baseReviews = reviewState.tab === "product" ? productReviewsData : storeReviewsData;
  let list = [...baseReviews];
  if (reviewState.rating !== "all") {
    const r = Number(reviewState.rating);
    list = list.filter((rv) => (rv.rating ?? 5) === r);
  }
  if (reviewState.tab === "product" && reviewState.photosOnly) {
    list = list.filter((rv) => !!rv.photo);
  }
  list.sort((a, b) => {
    switch (reviewState.sort) {
      case "latest":
        return a.ageMinutes - b.ageMinutes;
      case "oldest":
        return b.ageMinutes - a.ageMinutes;
      case "highest":
        return (b.rating ?? 5) - (a.rating ?? 5);
      case "lowest":
        return (a.rating ?? 5) - (b.rating ?? 5);
      default:
        return 0;
    }
  });
  return list;
}

function switchTab(next) {
  reviewState.tab = next;
  reviewState.expanded = false;
  reviewState.rating = "all";
  reviewState.photosOnly = false;
  reviewState.sort = "latest";
}

function starsRowHtml(rating) {
  const r = rating ?? 5;
  let h = "";
  for (let i = 0; i < 5; i++) h += i < r ? ICON.starFilled : ICON.starOutline;
  return `<div class="flex items-center gap-1">${h}</div>`;
}

function renderProductReviewsMount() {
  const root = document.getElementById("product-reviews-root");
  if (!root) return;

  const summary = reviewState.tab === "product" ? productSummary : storeSummary;
  const reviews = filteredSortedReviews();
  const visible = reviewState.expanded ? reviews : reviews.slice(0, 6);

  const distHtml = summary.distribution
    .map(
      (d) => `
    <button type="button" data-pr-stars="${d.stars}" class="flex w-full items-center gap-3 text-xs text-foreground/70 transition hover:text-foreground">
      <span class="w-3 text-right">${d.stars}</span>
      <div class="h-2 flex-1 overflow-hidden rounded-full bg-foreground/10">
        <div class="h-full rounded-full bg-[var(--brand-teal-deep)]" style="width:${d.pct}%"></div>
      </div>
      <span class="w-8 tabular-nums">${d.pct}%</span>
    </button>`,
    )
    .join("");

  const showClear = reviewState.rating !== "all" || reviewState.photosOnly || reviewState.sort !== "latest";
  const photosRow =
    reviewState.tab === "product"
      ? `<label class="ml-1 inline-flex cursor-pointer items-center gap-2 text-foreground/80">
           <input type="checkbox" id="pr-photos" class="h-4 w-4 rounded border-foreground/30 accent-[var(--brand-teal-deep)]" ${reviewState.photosOnly ? "checked" : ""}/>
           Photos & videos
         </label>`
      : "";

  const reviewsHtml =
    visible.length === 0
      ? `<div class="py-10 text-center text-sm text-foreground/60">No reviews match your filters.</div>`
      : visible
          .map((r) => {
            const key = voteKey(r);
            const voteState = reviewState.reviewVotes[key];
            const vote = voteState?.vote;
            const count = voteState?.count ?? baseHelpful(r);
            const photoBlock = r.photo
              ? `<img src="${escapeHtml(r.photo)}" alt="${escapeHtml(`Customer photo of LarineCo ${r.flavor ?? ""}`)}" loading="lazy" class="mt-3 h-28 w-28 rounded-xl object-cover"/>`
              : "";
            const flavorBlock = r.flavor
              ? `<div class="mt-3 text-xs text-foreground/60">Review for LarineCo Remineralizing Gum — ${escapeHtml(r.flavor)}</div>`
              : "";
            return `
    <article class="grid grid-cols-1 gap-4 py-6 sm:grid-cols-[160px_1fr_auto]">
      <div class="flex items-start gap-3">
        <div class="flex h-10 w-10 shrink-0 items-center justify-center rounded-full bg-[var(--brand-mint)] text-xs font-semibold text-[var(--brand-teal-deep)]">${escapeHtml(initials(r.name))}</div>
        <div class="min-w-0">
          <div class="flex items-center gap-1.5 text-sm font-medium text-foreground">
            ${escapeHtml(r.name)} ${ICON.gift}
          </div>
          <div class="mt-0.5 inline-flex items-center gap-1 text-xs text-foreground/70">
            ${ICON.checkVerifiedSm} Verified buyer
          </div>
        </div>
      </div>
      <div class="min-w-0">
        ${starsRowHtml(r.rating)}
        <h4 class="mt-2 text-base font-bold text-foreground">${escapeHtml(r.title)}</h4>
        <p class="mt-2 text-sm leading-relaxed text-foreground/85">${escapeHtml(r.body)}</p>
        ${photoBlock}
        ${flavorBlock}
        <div class="mt-3 inline-flex items-center gap-1.5 text-xs text-foreground/70">
          ${ICON.heart} Would recommend
        </div>
      </div>
      <div class="flex flex-row items-start justify-between gap-3 sm:flex-col sm:items-end">
        <span class="text-xs text-foreground/60">${escapeHtml(r.time)}</span>
        <div class="inline-flex items-center gap-1 text-xs text-foreground/70">
          <span>Helpful (${count})</span>
          <button type="button" aria-label="Mark helpful" aria-pressed="${vote === "up"}" data-vote-key="${encodeURIComponent(key)}" data-vote-dir="up" class="rounded p-1 transition hover:bg-foreground/5 ${vote === "up" ? "bg-[var(--brand-teal-deep)]/15 text-[var(--brand-teal-deep)]" : ""}">${ICON.chevronUp}</button>
          <span class="text-foreground/30">|</span>
          <button type="button" aria-label="Mark not helpful" aria-pressed="${vote === "down"}" data-vote-key="${encodeURIComponent(key)}" data-vote-dir="down" class="rounded p-1 transition hover:bg-foreground/5 ${vote === "down" ? "bg-rose-500/15 text-rose-500" : ""}">${ICON.chevronDown}</button>
        </div>
      </div>
    </article>`;
          })
          .join("");

  const moreBtn =
    reviews.length > 6
      ? `<div class="mt-6 flex justify-center">
           <button type="button" id="pr-expand" class="inline-flex items-center justify-center rounded-full bg-[var(--brand-teal-deep)] px-8 py-3 text-sm font-semibold text-white transition hover:opacity-90">${reviewState.expanded ? "Show fewer reviews" : "See more reviews"}</button>
         </div>`
      : "";

  root.innerHTML = `
<div class="rounded-3xl bg-[var(--brand-mint)]/30 p-6 sm:p-10">
  <div class="flex gap-6 border-b border-foreground/10 text-sm font-medium">
    <button type="button" id="pr-tab-product" class="px-1 pb-3 transition ${reviewState.tab === "product" ? "border-b-2 border-[var(--brand-teal-deep)] text-foreground" : "text-foreground/60 hover:text-foreground"}">
      Product reviews
    </button>
    <button type="button" id="pr-tab-store" class="px-1 pb-3 transition ${reviewState.tab === "store" ? "border-b-2 border-[var(--brand-teal-deep)] text-foreground" : "text-foreground/60 hover:text-foreground"}">
      Store reviews
    </button>
  </div>
  <div class="mt-6 flex flex-col gap-6 sm:flex-row sm:items-center">
    <div class="flex flex-col items-start">
      <div class="text-5xl font-semibold text-foreground">${summary.avg}</div>
      <div class="mt-1 flex items-center gap-1">${Array.from({ length: 5 }).map(() => ICON.starFilled).join("")}</div>
      <div class="mt-1 text-xs text-foreground/70">${summary.count}</div>
    </div>
    <div class="flex-1 space-y-1.5">${distHtml}</div>
  </div>
  <div class="mt-6 flex flex-wrap items-center gap-3 text-sm">
    <select id="pr-sort" class="rounded-md border border-foreground/15 bg-background px-3 py-2 text-foreground/80">
      <option value="latest">Sort by: Latest</option>
      <option value="oldest">Sort by: Oldest</option>
      <option value="highest">Sort by: Highest rated</option>
      <option value="lowest">Sort by: Lowest rated</option>
    </select>
    <select id="pr-rating" class="rounded-md border border-foreground/15 bg-background px-3 py-2 text-foreground/80">
      <option value="all">All ratings</option>
      <option value="5">5 stars</option>
      <option value="4">4 stars</option>
      <option value="3">3 stars</option>
      <option value="2">2 stars</option>
      <option value="1">1 star</option>
    </select>
    ${photosRow}
    ${
      showClear
        ? `<button type="button" id="pr-clear" class="ml-auto text-xs text-foreground/60 underline-offset-2 hover:text-foreground hover:underline">Clear filters</button>`
        : `<span class="ml-auto hidden sm:block"></span>`
    }
  </div>
  <div class="mt-4 divide-y divide-foreground/10">${reviewsHtml}</div>
  ${moreBtn}
</div>`;

  root.querySelector("#pr-sort").value = reviewState.sort;
  root.querySelector("#pr-rating").value = reviewState.rating;

  root.querySelector("#pr-tab-product")?.addEventListener("click", () => {
    switchTab("product");
    renderProductReviewsMount();
  });
  root.querySelector("#pr-tab-store")?.addEventListener("click", () => {
    switchTab("store");
    renderProductReviewsMount();
  });

  root.querySelector("#pr-sort")?.addEventListener("change", (e) => {
    reviewState.sort = /** @type {HTMLSelectElement} */ (e.target).value;
    reviewState.expanded = false;
    renderProductReviewsMount();
  });

  root.querySelector("#pr-rating")?.addEventListener("change", (e) => {
    reviewState.rating = /** @type {HTMLSelectElement} */ (e.target).value;
    reviewState.expanded = false;
    renderProductReviewsMount();
  });

  root.querySelector("#pr-photos")?.addEventListener("change", (e) => {
    reviewState.photosOnly = /** @type {HTMLInputElement} */ (e.target).checked;
    reviewState.expanded = false;
    renderProductReviewsMount();
  });

  root.querySelector("#pr-clear")?.addEventListener("click", () => {
    reviewState.rating = "all";
    reviewState.photosOnly = false;
    reviewState.sort = "latest";
    reviewState.expanded = false;
    renderProductReviewsMount();
  });

  root.querySelector("#pr-expand")?.addEventListener("click", () => {
    reviewState.expanded = !reviewState.expanded;
    renderProductReviewsMount();
  });

  bindReviewsDelegated(root);
}

function findReviewByKey(encoded) {
  const key = decodeURIComponent(encoded);
  const all = [...productReviewsData, ...storeReviewsData];
  return all.find((r) => voteKey(r) === key);
}

function bindReviewsDelegated(root) {
  root.querySelectorAll("[data-pr-stars]").forEach((btn) => {
    btn.addEventListener("click", () => {
      reviewState.rating = String(/** @type {HTMLButtonElement} */ (btn).dataset.prStars);
      reviewState.expanded = false;
      renderProductReviewsMount();
    });
  });

  root.querySelectorAll("[data-vote-key]").forEach((btn) => {
    btn.addEventListener("click", () => {
      const el = /** @type {HTMLButtonElement} */ (btn);
      const k = el.dataset.voteKey;
      const dir = /** @type {"up"|"down"} */ (el.dataset.voteDir);
      const r = k ? findReviewByKey(k) : undefined;
      if (r && (dir === "up" || dir === "down")) {
        handleVote(r, dir);
        renderProductReviewsMount();
      }
    });
  });
}

document.addEventListener("DOMContentLoaded", () => {
  const y = document.getElementById("footer-year");
  if (y) y.textContent = String(new Date().getFullYear());
  initNanoCompare();
  initTestimonialsCarousel();
  renderProductReviewsMount();
});
